import api from './api';

export interface Staff {
  id: string;
  email: string;
  role: 'admin' | 'manager';
  name: string;
  locationId?: string | null;
  csrfToken?: string; // Optional CSRF token returned in login response
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginResponse {
  data: Staff;
}

export const authService = {
  // Login
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await api.post('/auth/staff/login', credentials);
    return response.data;
  },

  // Logout
  async logout(): Promise<void> {
    await api.post('/auth/staff/logout');
  },

  // Get current user
  async getCurrentUser(): Promise<Staff> {
    const response = await api.get('/auth/staff/me');
    return response.data.data;
  },

  // Forgot password
  async forgotPassword(email: string): Promise<void> {
    await api.post('/auth/staff/forgot-password', { email });
  },

  // Reset password
  async resetPassword(token: string, newPassword: string): Promise<void> {
    await api.post('/auth/staff/reset-password', { token, newPassword });
  },

  // Refresh CSRF token
  async refreshCSRFToken(): Promise<string> {
    const response = await api.get('/auth/staff/csrf-token');
    const csrfToken = response.data.data.csrfToken;
    // Store in sessionStorage for cross-domain support
    if (csrfToken) {
      sessionStorage.setItem('csrfToken', csrfToken);
    }
    return csrfToken;
  },
};